const testHandle = (id: string) => `e2e-${id}` || 'provide-test-id'

export default testHandle
